<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">TYPES OF GOODS</h4>
					<button class="float-right btn btn-primary shadow mt-2"
					        v-on:click="formNewHardware=!formNewHardware">ADD NEW
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formNewHardware">
						<div class="row p-3 mx-2 bg-white shadow">
							
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">CATEGORY <span style="color:red;">*</span></label>
									<smart-search init url="/api/master/seeker/hardwaretype" key-tag="category"
								              :label-tag="['category']"
								              v-on:update="(data)=>updateNewHardwareItemType(data)">
									</smart-search>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">ITEM CODE<span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded" v-model="newHardware.partNumber"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">NAME OF GOODS<span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newHardware.hardwareName"/>
							</div>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="newHardwareSaved">
									<div class="alert alert-success" role="alert">
										Successfully saved new hardware.
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorNewHardware">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">Failed to save new hardware.</p>
										</div>
										<div v-for="err in errorNewHardwareList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="savingNewHardware">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Saving data, wait a moment.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button" v-on:click="saveNewHardware">
									Submit
								</button>
							</div>
						</div>
					</div>
				</transition>
				<div class="col-12  my-2 py-0">
						<datatable :currentIdx="currentPage" :datas="MasterHardwares" :structure="MasterHardwareTableStructure"
						           :init="datatable.loadData"
						           :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
						           use-seeker seeker-url="/api/master/seeker/hardware"
						           @refetch="(row)=>{rowLimit=row;getMasterHardwares()}"
						           @searching="(val)=>!val.status?getMasterHardwares():MasterHardwares=val.data"
						           @change-url="(url)=>getMasterHardwares(url+(url.includes('?')?'&':'?')+'limit='+rowLimit)">
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Kode barang:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												obj.part_number ? obj.part_number : "-"
											}}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Nama perangkat:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												obj.part_number ? obj.hardware_name : "-"
											}}</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Tipe perangkat:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.item }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<b-button v-b-modal.modal-edit-hardware class="btn btn-info mr-2"
											          v-on:click="selectedHardware=index;dataEdit=Object.assign({},obj)">
												<b-icon icon="pencil-square"></b-icon>
											</b-button>
											<button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj"
											        class="btn btn-danger">
												<b-icon icon="trash"></b-icon>
											</button>

										</div>
									</li>

								</ul>
							</td>
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.part_number ? obj.part_number : "-" }}</td>
							<td v-if="!isMobile">{{ obj.hardware_name }}</td>
							<td v-if="!isMobile">{{ obj.item }}</td>
							<td v-if="!isMobile">
								<b-button v-b-modal.modal-edit-hardware class="btn btn-info mr-2"
								          v-on:click="selectedHardware=index;dataEdit=Object.assign({},obj)">
									<b-icon icon="pencil-square"></b-icon>
								</b-button>
								<button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj"
								        class="btn btn-danger">
									<b-icon icon="trash"></b-icon>
								</button>
							</td>
						</template>
					</datatable>
				</div>
			</div>
		</div>
		<!-- <b-modal no-close-on-esc  content-class="m-0"  id="modal-delete-hardware" title="Konfirmasi hapus hardware" scrollable no-close-on-backdrop @hide="deleteModalClose">
			<b-container fluid v-if="!datatable.loadData && MasterHardwares.length>0">
				<b-row class="pt-1">
				  <b-col cols="12" class="my-3">
					  <h4>Apakah yakin mau menghapus data dengan detail berikut:</h4>
					  <ul>
						  <li>Hardware: {{MasterHardwares[selectedToDelete].hardware_name}}</li>
						  <li>tipe: {{MasterHardwares[selectedToDelete].item}}</li>
					  </ul>
				  </b-col>
				   <b-col cols="12" class="my-3 text-right"  v-if="deleteHardwareState">
					   <div class="d-flex align-items-center justify-content-start">
							<div class="spinner-border" role="status" aria-hidden="true"></div>
							<strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
						</div>
					</b-col>
					<div class="col-12 mt-3"  v-if="hardwareDeleted">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-success" role="alert">
								Berhasil menghapus data.
							</div>
						</div>
					</div>
					<div class="col-12 mt-3"  v-if="failDeleteHardware">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-danger" role="alert">
								Gagal menghapus data klien.
							</div>
						</div>
					</div>
				</b-row>
			</b-container>
			<template #modal-footer>
				<div class="w-100 text-right m-0 p-0">
				<hr>
				<button class="btn btn-danger  mr-2" v-on:click="deleteHardwareData">Ya, hapus</button>
				<b-button class="btn btn-secondary" @click="(!deleteHardwareState)?$bvModal.hide('modal-delete-hardware'):''">Tutup</b-button>
				</div>
			</template>
		</b-modal> -->
		<b-modal no-close-on-esc content-class="m-0" id="modal-edit-hardware" title="Detail informasi hardware"
		         scrollable no-close-on-backdrop size="lg" @hide="editModalClose">
			<b-container fluid v-if="!datatable.loadData && MasterHardwares.length>0">
				<b-row class="pt-1" v-if="MasterHardwares[selectedHardware]!=undefined">
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">Tipe Perangkat</label>
						<!-- <smart-select name="item_types" :options="itemTypeOptions" v-on:update="updateHardwareItemType"></smart-select> -->
						<smart-search init url="/api/master/seeker/hardwaretype" usedefault
						              :default-value="MasterHardwares[selectedHardware].item"
						              key-tag="category" :label-tag="['category']"
						              v-on:update="(data)=>smartSearchAddType(data)"></smart-search>
					</b-col>
					<b-col col="6"></b-col>
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">Kode Barang</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="MasterHardwares[selectedHardware].part_number"/>
					</b-col>
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">Nama Perangkat</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="MasterHardwares[selectedHardware].hardware_name"/>
					</b-col>

					<b-col cols="12" class="my-3 text-right" v-if="editHardwareState">
						<div class="d-flex align-items-center justify-content-start">
							<div class="spinner-border" role="status" aria-hidden="true"></div>
							<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
						</div>
					</b-col>
					<div class="col-12 mt-3" v-if="updateHardwareSaved">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-success" role="alert">
								Berhasil update data hardware.
							</div>
						</div>
					</div>
					<div class="col-12 mt-3" v-if="errorHardwareSaved">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-danger" role="alert">
								Gagal update data hardware.
							</div>
						</div>
					</div>
					<b-col cols="12" class="my-3 text-right">
						<button class="btn btn-info" v-on:click="updateHardwareData">Simpan</button>
					</b-col>
				</b-row>
			</b-container>
			<template #modal-footer>
				<div class="w-100 text-right m-0 p-0">
					<hr>
					<b-button class="btn btn-secondary mr-2"
					          @click="(!editHardwareState)?$bvModal.hide('modal-edit-hardware'):''">Tutup
					</b-button>
					<!-- <button class="btn btn-info" v-on:click="updateClientData">submit</button> -->
				</div>
			</template>
		</b-modal>

		<modal-delete url="/api/master/hardware/" @read="()=>{console.log('modal ready')}" @result="deleteResult"
		              :targetid="deleteId">
			Yakin mau menghapus data dengan detail berikut :<br>
			<ul>
				<li>Nama Perangkat: {{ itemToDelete.hardware_name }}</li>
				<li>Tipe Perangkat: {{ itemToDelete.item }}</li>
			</ul>
		</modal-delete>

	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import ModalDelete from "../../components/ModalDelete.vue";
import SmartSearch from "../../components/SmartSearch.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"modal-delete": ModalDelete,
		"smart-search": SmartSearch
	},
	data() {
		return {
			currentPage: 1,
			perPage: null,
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			isMobile: false,
			//step 1 edit
			dataEdit: null,
			datatable: {
				loadData: false
			},
			itemTypeOptions: [
				{label: "Antena", value: "antena"},
				{label: "JB", value: "jb"},
				{ label: "Aset", value: "Aset" },
				{ label: "Elektronik", value: "Elektronik" },
				{ label: "Stok", value: "Stok" },
				{ label: "Alat", value: "Alat" },
				{ label: "Umum", value: "Umum" },
				{ label: "Tx", value: "Transmitter" },
  				{ label: "JB", value: "Junction box" }
			],
			newHardware: {
				hardwareName: "",
				partNumber: "",
				item: ""
			},
			itemToDelete: {},
			deleteId: 0,
			errorHardwareSaved: false,
			updateHardwareSaved: false,
			editHardwareState: false,
			deleteHardwareState: false,
			failDeleteHardware: false,
			hardwareDeleted: false,
			MasterHardwares: [],
			errorNewHardwareList: [],
			formNewHardware: false,
			errorNewHardware: false,
			savingNewHardware: false,
			newHardwareSaved: false,
			searchValue: "",
			selectedToDelete: 0,
			selectedHardware: 0,
			MasterHardwareTableStructure: [
				{label: "NO", key: null},
				{label: "ITEM CODE", key: null},
				{label: "NAME OF GOODS", key: null},
				{label: "CATEGORY", key: null},
				{label: "ACTIONS", key: null}
			]
		};
	},
	created() {
		console.clear();
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		console.log("hardware page");
		this.getMasterHardwares();
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			console.log("screen update");
			this.isMobile = screen.width < 768;
		});
	},
	methods: {
		changePage(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = parseInt(myParams);
			var newUrl = this.$baseUrl + "/api/master/hardware?limit=" + this.rowLimit + "&page=" + myParams;
			this.getMasterHardwares(newUrl);
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getMasterHardwares();
			}
		},
		getMasterHardwares(url = (this.$baseUrl + "/api/master/hardware?limit=" + this.rowLimit)) {
			this.datatable.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.datatable.loadData = false;
				this.MasterHardwares = result.data.data;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.datatable.loadData = false;
			});
		},
		updateHardwareItemType(value) {
			this.MasterHardwares[this.selectedHardware].item = value;
		},
		updateNewHardwareItemType(value) {
			console.log(value);
			// this.newHardware.item = value.hardware_type_name;
			this.newHardware.item = value.category;
		},
		saveNewHardware() {
			this.savingNewHardware = true;
			this.errorNewHardware = false;
			this.errorNewHardwareList = [];
			if (this.newHardware.hardwareName == "") {
				this.errorNewHardwareList.push(["- Mohon isi nama hardware"]);
			}
			if (this.newHardware.partNumber == "") {
				this.errorNewHardwareList.push(["- Mohon isi kode barang"]);
			}
			if (this.newHardware.item == "") {
				this.errorNewHardwareList.push(["- Mohon isi tipe"]);
			}
			console.log(this.errorNewHardwareList);
			console.log(this.newUser);
			if (this.newHardware.hardwareName != "" && this.newHardware.item != "") {

				axios.post(
					this.$baseUrl + "/api/master/hardware",
					{
						hardware_name: this.newHardware.hardwareName,
						part_number: this.newHardware.partNumber,
						item: this.newHardware.item
					},
					{
						"headers":
							{
								"Authorization": "Bearer " + localStorage.getItem("accessToken")
							}
					}
				).then((result) => {
					//console.log(result)
					if (result.data.create) {
						this.getMasterHardwares();
					}
					this.newHardware.hardwareName = "",
						this.newHardware.item = "",
						this.savingNewHardware = false;
					this.newHardwareSaved = true;

					setTimeout(() => {
						this.newHardwareSaved = false;
						this.formNewHardware = false;
					}, 1500);

				}).catch((err) => {
					//check if token fail
					if (err.response && err.response.status == 401) {
						localStorage.removeItem("accessToken");
						this.$router.push("/login");
					}
					console.log(err.response);
					this.errorNewHardwareList = [];
					this.errorNewUserList = Object.values(err.response.data.errors);
					console.log(this.errorNewUserList);
					this.errorNewHardware = true;
					this.savingNewHardware = false;
				});
			} else {
				this.errorNewHardware = true;
				this.savingNewHardware = false;
			}
		},
		deleteItem(idx) {
			this.selectedToDelete = idx;
		},
		deleteHardwareData() {
			console.log("deleting data");
			this.deleteHardwareState = true;
			axios.delete(this.$baseUrl + "/api/master/hardware/" + this.MasterHardwares[this.selectedToDelete].id, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				if (result.status == 200) {
					this.deleteHardwareState = false;
					this.hardwareDeleted = true;

					setTimeout(() => {
						this.MasterHardwares.splice(this.selectedToDelete, 1);
						this.$bvModal.hide("modal-delete-hardware");
						this.hardwareDeleted = false;
					}, 1500);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.deleteHardwareState = false;
				this.failDeleteHardware = true;
				setTimeout(() => {
					this.failDeleteHardware = false;
				}, 1500);
				console.log(err);
			});
		},
		deleteModalClose(mdl) {
			if (this.deleteHardwareState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-user");
			}
		},
		editModalClose(mdl) {
			//step 2 edit
			this.$set(this.MasterHardwares, this.selectedHardware, this.dataEdit);
			//step 3 edit
			this.dataEdit = Object.assign({}, null);
			if (this.editHardwareState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-user");
			}
		},
		updateHardwareData() {
			console.log("updating data");
			this.editHardwareState = true;
			axios.put(this.$baseUrl + "/api/master/hardware/" + this.MasterHardwares[this.selectedHardware].id,
			          this.MasterHardwares[this.selectedHardware]
				, {
				          "headers": {
					          "Authorization": "Bearer " + localStorage.getItem("accessToken")
				          }
			          }
			).then((result) => {
				if (result.status == 200) {
					this.editHardwareState = false;
					this.updateHardwareSaved = true;
					//step 4 edit
					this.dataEdit = this.MasterHardwares[this.selectedHardware];
					setTimeout(() => {
						this.updateHardwareSaved = false;
						this.$bvModal.hide("modal-edit-hardware");
					}, 1000);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.editHardwareState = false;
				this.errorHardwareSaved = true;
				setTimeout(() => {
					this.errorHardwareSaved = false;
				}, 1000);
				console.log(err);
			});
		},
		smartSearchAddType(data) {
			console.clear();
			this.MasterHardwares[this.selectedHardware].item = data.category;
			console.log("new client id:" + this.MasterHardwares[this.selectedHardware].item);

			// this.newHardware.item=data.hardware_type_name
		}

	}
};
</script>
<style scoped>
.btn {
	padding: 2px 6px;
}
</style>
